import React from 'react';
import { Bot, Map, TrendingUp, Building2, DollarSign, Users } from 'lucide-react';

const AboutPage: React.FC = () => {
  return (
    <div className="max-w-4xl mx-auto space-y-12">
      <div className="text-center space-y-4">
        <h1 className="text-4xl font-bold text-primary">About Location Scout</h1>
        <p className="text-xl text-muted-foreground">
          Your Partner in finding the perfect business location
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
        <div className="bg-card/50 backdrop-blur-sm border border-border rounded-lg p-6 space-y-4">
          <Bot className="text-primary" size={32} />
          <h2 className="text-2xl font-semibold">AI-Powered Analysis</h2>
          <p className="text-muted-foreground">
            Our advanced AI algorithms analyze multiple data points to provide accurate location insights and business opportunities.
          </p>
        </div>

        <div className="bg-card/50 backdrop-blur-sm border border-border rounded-lg p-6 space-y-4">
          <Map className="text-primary" size={32} />
          <h2 className="text-2xl font-semibold">Location Intelligence</h2>
          <p className="text-muted-foreground">
            Get detailed insights about foot traffic, nearby businesses, and growth potential for any location.
          </p>
        </div>

        <div className="bg-card/50 backdrop-blur-sm border border-border rounded-lg p-6 space-y-4">
          <TrendingUp className="text-primary" size={32} />
          <h2 className="text-2xl font-semibold">Market Analysis</h2>
          <p className="text-muted-foreground">
            Understand market trends, competition levels, and growth opportunities in your chosen area.
          </p>
        </div>

        <div className="bg-card/50 backdrop-blur-sm border border-border rounded-lg p-6 space-y-4">
          <Building2 className="text-primary" size={32} />
          <h2 className="text-2xl font-semibold">Business Insights</h2>
          <p className="text-muted-foreground">
            Get recommendations tailored to your business type and budget constraints.
          </p>
        </div>
      </div>

      <div className="bg-card/50 backdrop-blur-sm border border-border rounded-lg p-8">
        <h2 className="text-2xl font-semibold mb-6">How It Works</h2>
        <div className="space-y-6">
          <div className="flex items-start space-x-4">
            <div className="bg-primary/10 p-3 rounded-full">
              <Map className="text-primary" size={24} />
            </div>
            <div>
              <h3 className="font-semibold">1. Enter Location</h3>
              <p className="text-muted-foreground">Specify your target area for analysis</p>
            </div>
          </div>

          <div className="flex items-start space-x-4">
            <div className="bg-primary/10 p-3 rounded-full">
              <Building2 className="text-primary" size={24} />
            </div>
            <div>
              <h3 className="font-semibold">2. Business Details</h3>
              <p className="text-muted-foreground">Tell us about your business type and budget</p>
            </div>
          </div>

          <div className="flex items-start space-x-4">
            <div className="bg-primary/10 p-3 rounded-full">
              <Bot className="text-primary" size={24} />
            </div>
            <div>
              <h3 className="font-semibold">3. AI Analysis</h3>
              <p className="text-muted-foreground">Our AI analyzes multiple data points</p>
            </div>
          </div>

          <div className="flex items-start space-x-4">
            <div className="bg-primary/10 p-3 rounded-full">
              <TrendingUp className="text-primary" size={24} />
            </div>
            <div>
              <h3 className="font-semibold">4. Get Insights</h3>
              <p className="text-muted-foreground">Receive detailed location analysis and recommendations</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutPage;